import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthLayout } from "../../components/AuthLayout";
import { api } from "../../lib/api";
import { ErrorMessage } from "../../components/ErrorMessage";
import { Field } from "../../components/Field";

function friendly(message) {
  return String(message || "Something went wrong.").replace(/^\d{3}\s+/, "");
}

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      // The endpoint always answers 200 — it never reveals whether the
      // address has an account — so success here just means "request made".
      await api.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(friendly(err.message));
      setBusy(false);
    }
  }

  return (
    <AuthLayout
      title="Reset your password"
      subtitle={
        sent
          ? undefined
          : "Enter your email and we'll send a link to set a new password."
      }
      footer={
        <span>
          Remembered it? <Link to="/login">Back to sign in</Link>
        </span>
      }
    >
      {sent ? (
        <div className="auth-msg" role="status">
          If an account exists for <b>{email}</b>, a password-reset link is on
          its way. Check your inbox.
        </div>
      ) : (
        <form className="auth-form" onSubmit={onSubmit}>
          <ErrorMessage message={error} />

          <Field variant="auth" label="Email">
            <input
              type="email"
              className="input"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Field>

          <button type="submit" className="btn primary auth-submit" disabled={busy}>
            {busy ? "Sending…" : "Send reset link"}
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
